import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  guidelines: [],
  guideline: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_GUIDELINES (state, payload) {
    state.guidelines = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  SET_GUIDELINE (state, payload) {
    state.guideline = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  guidelineList: (context, id) => {
    return Vue.http.get(`${env.API}/api/guideline`)    
      .then((response) => {        
        context.commit('SET_GUIDELINES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  paginatedList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/guideline/paginated-list`, data)    
      .then((response) => {        
        context.commit('SET_GUIDELINES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  },
  deleteGuideline: (context, data) => {
    return Vue.http.delete(`${env.API}/api/guideline/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  getGuidelineById: (context, id) => {
    return Vue.http.get(`${env.API}/api/guideline/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_GUIDELINE', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateGuideline: (context, data) => {
    return Vue.http.put(`${env.API}/api/guideline/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createGuideline: (context, data) => {
    return Vue.http.post(`${env.API}/api/guideline`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateSortAd: (context, data) => {
    return context.commit('SET_SORT_AD', data)
  }
}

const getters = {
  getGuidelines: (state) => state.guidelines,
  getGuideline: (state) => state.guideline,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const guideline = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline.js